import React, { useState, useEffect } from 'react';
import Sidebar from '../components/dashboardContent/Sidebar';
import AllFichesTechniques from './dashboardContent/AllFichesTechniques';
import FicheTechnique from './dashboardContent/FicheTechnique';
import Form from '../components/dashboardContent/Form';
import Report from '../components/dashboardContent/Report';
import ImportFileExcel from '../components/dashboardContent/ImportFileExcel';
import PageLayout from '../components/dashboardContent/PageLayout';
import OriginalInstitution from '../components/dashboardContent/OriginalInstitution';
import StudentSelector from '../components/dashboardContent/StudentSelector';
import ContactUs from '../components/dashboardContent/ContactUs';
import EtablissementAccueil from '../components/dashboardContent/EtablissementAccueil';
import PageLayout2 from '../components/dashboardContent/PageLayout2';
import LeSeuil from '../components/dashboardContent/LeSeuil';
import InputNotes from '../components/dashboardContent/InputNotes';
import DeuxiemeLangueSelonDepartement from '../components/dashboardContent/DeuxiemeLangueSelonDepartement';
import PageLayout3 from '../components/dashboardContent/PageLayout3';
import EtudiantsInterieurVille from '../components/dashboardContent/EtudiantsInterieurVille';
import RepartitionDesElevesOrientes  from '../components/dashboardContent/RepartitionDesElevesOrientes';
import DistributionStudentsOutsideCity  from '../components/dashboardContent/DistributionStudentsOutsideCity';
import MinutesOfDepartmentCouncilDecision  from '../components/dashboardContent/MinutesOfDepartmentCouncilDecision';
import MinutesOfDepartmentCouncilDecision1  from '../components/dashboardContent/MinutesOfDepartmentCouncilDecision1';
import ListeEtudiantsExclus  from '../components/dashboardContent/ListeEtudiantsExclus';
import GradeScale  from '../components/dashboardContent/GradeScale';
import ResultatsDesConseils  from '../components/dashboardContent/ResultatsDesConseils';

//-----------------------------------------------------------------------------------------------------------------------
import PageLayoutVersion2 from './dashboardContentV2/PageLayout';
import ImportFileExcelV2 from './dashboardContentV2/ImportFileExcel';
import OriginalInstitutionV2 from './dashboardContentV2/OriginalInstitution';
import StudentSelectorV2 from './dashboardContentV2/StudentSelector';
import EtablissementAccueilV2 from './dashboardContentV2/EtablissementAccueil';
import PageLayout2V2 from './dashboardContentV2/PageLayout2';
import LeSeuilV2 from './dashboardContentV2/LeSeuil';
import InputNotesV2 from './dashboardContentV2/InputNotes';
import DeuxiemeLangueSelonDepartementV2 from './dashboardContentV2/DeuxiemeLangueSelonDepartement';
import PageLayout3V2 from './dashboardContentV2/PageLayout3';
import EtudiantsInterieurVilleV2 from './dashboardContentV2/EtudiantsInterieurVille';
import RepartitionDesElevesOrientesV2  from './dashboardContentV2/RepartitionDesElevesOrientes';
import DistributionStudentsOutsideCityV2  from './dashboardContentV2/DistributionStudentsOutsideCity';
import MinutesOfDepartmentCouncilDecisionV2  from './dashboardContentV2/MinutesOfDepartmentCouncilDecision';
import MinutesOfDepartmentCouncilDecision1V2  from './dashboardContentV2/MinutesOfDepartmentCouncilDecision1';
import ListeEtudiantsExclusV2  from './dashboardContentV2/ListeEtudiantsExclus';
import GradeScaleV2  from './dashboardContentV2/GradeScale';
import ResultatsDesConseilsV2  from './dashboardContentV2/ResultatsDesConseils';
import TableAV2  from './dashboardContentV2/TableA';
//-----------------------------------------------------------------------------------------------------------------------
import PageLayoutVersion3 from './dashboardContentV3/PageLayout';
import ImportFileExcelV3 from './dashboardContentV3/ImportFileExcel';
import OriginalInstitutionV3 from './dashboardContentV3/OriginalInstitution';
import StudentSelectorV3 from './dashboardContentV3/StudentSelector';
import EtablissementAccueilV3 from './dashboardContentV3/EtablissementAccueil';
import PageLayout2V3 from './dashboardContentV3/PageLayout2';
import LeSeuilV3 from './dashboardContentV3/LeSeuil';
import InputNotesV3 from './dashboardContentV3/InputNotes';
import DeuxiemeLangueSelonDepartementV3 from './dashboardContentV3/DeuxiemeLangueSelonDepartement';
import PageLayout3V3 from './dashboardContentV3/PageLayout3';
import EtudiantsInterieurVilleV3 from './dashboardContentV3/EtudiantsInterieurVille';
import RepartitionDesElevesOrientesV3  from './dashboardContentV3/RepartitionDesElevesOrientes';
import DistributionStudentsOutsideCityV3  from './dashboardContentV3/DistributionStudentsOutsideCity';
import MinutesOfDepartmentCouncilDecisionV3  from './dashboardContentV3/MinutesOfDepartmentCouncilDecision';
import MinutesOfDepartmentCouncilDecision1V3 from './dashboardContentV3/MinutesOfDepartmentCouncilDecision1';
import ListeEtudiantsExclusV3  from './dashboardContentV3/ListeEtudiantsExclus';
import GradeScaleV3  from './dashboardContentV3/GradeScale';
import ResultatsDesConseilsV3  from './dashboardContentV3/ResultatsDesConseils';
import TableAV3  from './dashboardContentV3/TableA';




import { useNavigate, useLocation } from 'react-router-dom';



import Image1 from '../Images/Photo1.PNG';
import '../StylesCSS/Dashboard.css';


const Dashboard = ({ handleLogout }) => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('');

 // const [activeSection, setActiveSection] = useState('form');
 useEffect(() => {
  // Dynamically set the active section based on the current route
  const path = location.pathname.substring(1); // Remove the leading '/'
  setActiveSection(path);
}, [location]);
  

  const renderSection = () => {
    switch (activeSection) {
      case 'AllFichesTechniques':
        return <AllFichesTechniques />;
      case 'FicheTechnique':
        return <FicheTechnique setActiveSection={setActiveSection}/>;
      case 'form':
        return <Form />;
      case 'Report':
        return <Report/>
      case 'PageLayout':
        return <PageLayout setActiveSection={setActiveSection} />;
      case 'ImportFileExcel':
        return <ImportFileExcel setActiveSection={setActiveSection} />;
      case 'OriginalInstitution':
        return <OriginalInstitution setActiveSection={setActiveSection} />;
      case 'StudentSelector':
          return <StudentSelector setActiveSection={setActiveSection} />;
      case 'ContactUs':
            return <ContactUs setActiveSection={setActiveSection} />;
      case 'PageLayout2':
            return <PageLayout2 setActiveSection={setActiveSection} />;
      case 'EtablissementAccueil':
            return <EtablissementAccueil setActiveSection={setActiveSection} />;
      case 'LeSeuil':
            return <LeSeuil setActiveSection={setActiveSection} />;
      case 'InputNotes':
            return <InputNotes setActiveSection={setActiveSection} />;
      case 'DeuxiemeLangueSelonDepartement':
              return <DeuxiemeLangueSelonDepartement setActiveSection={setActiveSection} />;
      case 'PageLayout3':
              return <PageLayout3 setActiveSection={setActiveSection} />;
      case 'RepartitionDesElevesOrientes':
             return <RepartitionDesElevesOrientes setActiveSection={setActiveSection} />;
      case 'EtudiantsInterieurVille':
            return <EtudiantsInterieurVille setActiveSection={setActiveSection} />;
      case 'DistributionStudentsOutsideCity':
            return <DistributionStudentsOutsideCity setActiveSection={setActiveSection} />;
      case 'MinutesOfDepartmentCouncilDecision':
            return <MinutesOfDepartmentCouncilDecision setActiveSection={setActiveSection} />;
      case 'MinutesOfDepartmentCouncilDecision1':
            return <MinutesOfDepartmentCouncilDecision1 setActiveSection={setActiveSection} />;
      case 'ResultatsDesConseils':
            return <ResultatsDesConseils setActiveSection={setActiveSection} />;    
      case 'ListeEtudiantsExclus':
            return <ListeEtudiantsExclus setActiveSection={setActiveSection} />;   
      case 'GradeScale':
            return <GradeScale setActiveSection={setActiveSection} />; 
            
            

      case 'PageLayoutVersion2':
              return <PageLayoutVersion2 setActiveSection={setActiveSection} />;   
      case 'ImportFileExcelV2':
              return <ImportFileExcelV2 setActiveSection={setActiveSection} />;
      case 'OriginalInstitutionV2':
              return <OriginalInstitutionV2 setActiveSection={setActiveSection} />;
      case 'StudentSelectorV2':
              return <StudentSelectorV2 setActiveSection={setActiveSection} />;
      case 'PageLayout2V2':
              return <PageLayout2V2 setActiveSection={setActiveSection} />;
      case 'EtablissementAccueilV2':
              return <EtablissementAccueilV2 setActiveSection={setActiveSection} />;
      case 'LeSeuilV2':
              return <LeSeuilV2 setActiveSection={setActiveSection} />;
      case 'InputNotesV2':
              return <InputNotesV2 setActiveSection={setActiveSection} />;
      case 'DeuxiemeLangueSelonDepartementV2':
              return <DeuxiemeLangueSelonDepartementV2 setActiveSection={setActiveSection} />;
      case 'PageLayout3V2':
              return <PageLayout3V2 setActiveSection={setActiveSection} />;
      case 'RepartitionDesElevesOrientesV2':
              return <RepartitionDesElevesOrientesV2 setActiveSection={setActiveSection} />;
      case 'EtudiantsInterieurVilleV2':
              return <EtudiantsInterieurVilleV2 setActiveSection={setActiveSection} />;
      case 'DistributionStudentsOutsideCityV2':
              return <DistributionStudentsOutsideCityV2 setActiveSection={setActiveSection} />;
      case 'MinutesOfDepartmentCouncilDecisionV2':
              return <MinutesOfDepartmentCouncilDecisionV2 setActiveSection={setActiveSection} />;
      case 'MinutesOfDepartmentCouncilDecision1V2':
              return <MinutesOfDepartmentCouncilDecision1V2 setActiveSection={setActiveSection} />;
      case 'ResultatsDesConseilsV2':
              return <ResultatsDesConseilsV2 setActiveSection={setActiveSection} />;    
      case 'ListeEtudiantsExclusV2':
              return <ListeEtudiantsExclusV2 setActiveSection={setActiveSection} />;   
      case 'GradeScaleV2':
                    return <GradeScaleV2 setActiveSection={setActiveSection} />; 
      case 'TableAV2':
                        return <TableAV2 setActiveSection={setActiveSection} />; 


    case 'PageLayoutVersion3':
              return <PageLayoutVersion3 setActiveSection={setActiveSection} />;   
      case 'ImportFileExcelV3':
              return <ImportFileExcelV3 setActiveSection={setActiveSection} />;
      case 'OriginalInstitutionV3':
              return <OriginalInstitutionV3 setActiveSection={setActiveSection} />;
      case 'StudentSelectorV3':
              return <StudentSelectorV3 setActiveSection={setActiveSection} />;
      case 'PageLayout2V3':
              return <PageLayout2V3 setActiveSection={setActiveSection} />;
      case 'EtablissementAccueilV3':
              return <EtablissementAccueilV3 setActiveSection={setActiveSection} />;
      case 'LeSeuilV3':
              return <LeSeuilV3 setActiveSection={setActiveSection} />;
      case 'InputNotesV3':
              return <InputNotesV3 setActiveSection={setActiveSection} />;
      case 'DeuxiemeLangueSelonDepartementV3':
              return <DeuxiemeLangueSelonDepartementV3 setActiveSection={setActiveSection} />;
      case 'PageLayout3V3':
              return <PageLayout3V3 setActiveSection={setActiveSection} />;
      case 'RepartitionDesElevesOrientesV3':
              return <RepartitionDesElevesOrientesV3 setActiveSection={setActiveSection} />;
      case 'EtudiantsInterieurVilleV3':
              return <EtudiantsInterieurVilleV3 setActiveSection={setActiveSection} />;
      case 'DistributionStudentsOutsideCityV3':
              return <DistributionStudentsOutsideCityV3 setActiveSection={setActiveSection} />;
      case 'MinutesOfDepartmentCouncilDecisionV3':
              return <MinutesOfDepartmentCouncilDecisionV3 setActiveSection={setActiveSection} />;
      case 'MinutesOfDepartmentCouncilDecision1V3':
              return <MinutesOfDepartmentCouncilDecision1V3 setActiveSection={setActiveSection} />;
      case 'ResultatsDesConseilsV3':
              return <ResultatsDesConseilsV3 setActiveSection={setActiveSection} />;    
      case 'ListeEtudiantsExclusV3':
              return <ListeEtudiantsExclusV3 setActiveSection={setActiveSection} />;   
      case 'GradeScaleV3':
                    return <GradeScaleV3 setActiveSection={setActiveSection} />; 
      case 'TableAV3':
                        return <TableAV3 setActiveSection={setActiveSection} />; 
            
      default:
        return <Form />;
    }
  };

  return (
    <div style={{ display: "flex", height: "100vh" }} className="d-flex" id="wrapper">
      <Sidebar setActiveSection={setActiveSection} handleLogout={handleLogout} />
      <div id="page-content-wrapper">
        <div className="container-fluid">
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <img src={Image1} alt="Dashboard Header" style={{ width: '400px', height: '100px' }} />
          </div>
          {renderSection()}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
